import classnames from 'classnames';
import * as styles from './Icon.module.scss';

export enum IconColor {
    black = 'black',
    danger = 'danger',
    gray = 'gray',
    muted = 'muted',
    primary = 'primary',
    secondary = 'secondary',
    success = 'success',
    white = 'white',
}

function renderIcon(props: {
    className?: string;
    color?: IconColor;
    icon: string;
    size?: 'small' | 'medium' | 'large' | 'xlarge';
}) {
    const icon = props.icon.toLowerCase();
    let classNames = `icon icon-${icon}`;

    if (props.color) {
        classNames += ` is-${props.color}`;
    }

    return (
        <div
            className={classnames(classNames, styles.icon, props.size ? styles[props.size] : '', props.className || '')}
        >
            <svg
                className={classnames('icon-' + icon)}
                viewBox="0 0 100 100"
            >
                <use xlinkHref={'/images/svg-sprite.svg#icon-' + icon}></use>
            </svg>
        </div>
    );
}

export function Icon(props: {
    className?: string;
    color?: IconColor;
    icon: string;
    size?: 'small' | 'medium' | 'large' | 'xlarge';
}) {
    return renderIcon(props);
}
